"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * 大得到日志统计
 * 在原版基础上修改了一下，添加了 igetcool 的域名，去掉了大得到的域名判断
 * @author qiaogang
 * @date 2019-12-18
 */
function initLa() {
  /* global _la */
  window._la = [];
  var ORP = ['push', 'pop'];
  var intLength = 0; // let getUrl = 'http://logs-test-online.luojilab.com'

  var getUrl = 'https://logserver.igetcool.com'; // 测试、仿真域名规则：-dev.igctool.com; -sim.igetcool.com; test1-3.igetcool.com; qa-test.igetcool.com;

  var regExp = /\.igetcool\.com$/i;
  var testRegExp = /(dev|sim|test).*\.igetcool\.com$/i;

  if (regExp.test(location.hostname)) {
    // getUrl = 'https://logs.luojilab.com';
    getUrl = 'https://logserver.igetcool.com';

    if (testRegExp.test(location.hostname)) {
      // getUrl = 'http://logs-test-online.luojilab.com';
      getUrl = 'https://logserver-test.igetcool.com';
    }
  }

  var arrayToObject = function arrayToObject(array, obj) {
    for (var i in array) {
      obj[array[i][0]] = array[i][1];
    }

    return obj;
  };

  var objectToArgs = function objectToArgs(object) {
    var args = '';

    for (var i in object) {
      args !== '' && (args += '&');
      args += i + '=' + encodeURIComponent(object[i]);
    }

    return args;
  };

  var call = function call() {
    // 处理大得到连续两次发送时，第二次发送可能会中断第一次发送的问题
    var img = new Image();

    img.onload = function () {
      img = null;
    };

    img.onerror = function () {
      img = null;
    };

    img.src = getUrl + '/log.gif?' + objectToArgs(arrayToObject(_la, {}));
    _la.length = intLength;
  };

  var cloneArray = function cloneArray() {
    var arrayProto = Array.prototype;
    var newProto = Object.create(arrayProto);
    ORP.forEach(function (prop) {
      Object.defineProperty(newProto, prop, {
        value: function value() {
          [].push(prop);
          arrayProto[prop].apply(_la, arguments);
          call();
        },
        enumerable: false,
        configurable: true,
        writable: true
      });
    });
    /* eslint no-proto: "off" */

    _la.__proto__ = newProto;
  };

  var Watch = /*#__PURE__*/function () {
    function Watch() {
      _classCallCheck(this, Watch);
    }

    _createClass(Watch, [{
      key: "observe",
      value: function observe() {
        var type = Object.prototype.toString.call(_la);
        type === '[object Array]' && cloneArray();
      }
    }]);

    return Watch;
  }();

  _la && (intLength = _la.length);
  var analysis = new Watch();
  analysis.observe();
}

var _default = {
  init: initLa
};
exports["default"] = _default;